module.exports = ""


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/login/landing-page-login/landing-page-login.component.html
// module id = ../../../../../src/app/components/login/landing-page-login/landing-page-login.component.html
// module chunks = main